import React from 'react';
import { TrendingUp, DollarSign } from 'lucide-react';
interface ModelStats {
  count: number;
  volume: number;
  commissions: number;
  avgCommission: number;
}
interface SummaryBarProps {
  flatFeeStats: ModelStats;
  regularStats: ModelStats;
}
export function SummaryBar({
  flatFeeStats,
  regularStats
}: SummaryBarProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-121">
      {/* Flat Fee Summary */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-indigo-500 p-6 transition-transform hover:scale-[1.01] duration-200" data-id="element-122">
        <div className="flex items-center justify-between mb-6" data-id="element-123">
          <h3 className="text-lg font-bold text-slate-800 flex items-center" data-id="element-124">
            Flat Fee Model
          </h3>
          <span className="bg-indigo-50 text-indigo-700 text-xs font-bold px-3 py-1 rounded-full border border-indigo-100" data-id="element-125">
            {flatFeeStats.count} Loans
          </span>
        </div>

        <div className="grid grid-cols-2 gap-6 divide-x divide-slate-100" data-id="element-126">
          <div className="pr-2" data-id="element-127">
            <p className="text-xs font-semibold text-slate-500 mb-1.5 flex items-center uppercase tracking-wide" data-id="element-128">
              <TrendingUp className="w-3.5 h-3.5 mr-1.5 text-slate-400" data-id="element-129" /> Total
              Volume
            </p>
            <p className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-130">
              {formatCurrency(flatFeeStats.volume)}
            </p>
          </div>
          <div className="pl-6" data-id="element-131">
            <p className="text-xs font-semibold text-slate-500 mb-1.5 flex items-center uppercase tracking-wide" data-id="element-132">
              <DollarSign className="w-3.5 h-3.5 mr-1.5 text-slate-400" data-id="element-133" /> Total
              Paid
            </p>
            <p className="text-2xl font-bold text-indigo-600 tracking-tight" data-id="element-134">
              {formatCurrency(flatFeeStats.commissions)}
            </p>
          </div>
        </div>
      </div>

      {/* Regular Summary */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 border-l-4 border-l-emerald-500 p-6 transition-transform hover:scale-[1.01] duration-200" data-id="element-135">
        <div className="flex items-center justify-between mb-6" data-id="element-136">
          <h3 className="text-lg font-bold text-slate-800 flex items-center" data-id="element-137">
            Regular Model
          </h3>
          <span className="bg-emerald-50 text-emerald-700 text-xs font-bold px-3 py-1 rounded-full border border-emerald-100" data-id="element-138">
            {regularStats.count} Loans
          </span>
        </div>

        <div className="grid grid-cols-2 gap-6 divide-x divide-slate-100" data-id="element-139">
          <div className="pr-2" data-id="element-140">
            <p className="text-xs font-semibold text-slate-500 mb-1.5 flex items-center uppercase tracking-wide" data-id="element-141">
              <TrendingUp className="w-3.5 h-3.5 mr-1.5 text-slate-400" data-id="element-142" /> Total
              Volume
            </p>
            <p className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-143">
              {formatCurrency(regularStats.volume)}
            </p>
          </div>
          <div className="pl-6" data-id="element-144">
            <p className="text-xs font-semibold text-slate-500 mb-1.5 flex items-center uppercase tracking-wide" data-id="element-145">
              <DollarSign className="w-3.5 h-3.5 mr-1.5 text-slate-400" data-id="element-146" /> Total
              Paid
            </p>
            <p className="text-2xl font-bold text-emerald-600 tracking-tight" data-id="element-147">
              {formatCurrency(regularStats.commissions)}
            </p>
          </div>
        </div>
      </div>
    </div>;
}